// --------------------------------------------------------------
// Created On: 2023-02-17
// Author: Zachary Thomas
//
// Last Modified: 2025-12-30
// Modified By: Hannah Vaughan
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useMemo } from "react";
import Card from "../../components/Card/Card";
import styles from "./PolicyPage.module.scss";
import DangerousHtmlContent from "./DangerousHtmlContent/DangerousHtmlContent";
import { Link } from "react-router-dom";

// Page for viewing policy PDFs.
export default function PolicyPage(props: Props): Component {
  const alternatePolicyUrl = useMemo(() => getAlternatePolicyUrl(props.policyType), [props.policyType]);

  // Get the correct URL for the alternate policy type.
  function getAlternatePolicyUrl(policyType: "Privacy Policy" | "Terms and Conditions of Sale"): string {
    if (policyType === "Privacy Policy") {
      return "/terms-and-conditions-of-sale-text";
    } else {
      return "/privacy-policy-text";
    }
  }

  return (
    <div className={`${styles.body} p-4`} data-test="policy-card">
      <Card title={props.policyType} fullWidth>
        <div className={`${styles.buttonHeader} pt-1 pb-4`}>
          <Link className="m-2" to={alternatePolicyUrl}>
            <button className="btn btn-primary" data-test="switch-legal-policy-button">
              {props.policyType === "Privacy Policy" ? "View Terms and Conditions of Sale" : "View Privacy Policy"}
            </button>
          </Link>
        </div>

        {props.policyType === "Privacy Policy" ? (
          <DangerousHtmlContent fileUrl="/legal/Privacy_Policy.html" />
        ) : (
          <DangerousHtmlContent fileUrl="/legal/Terms_And_Conditions_Of_Sale.html" />
        )}
      </Card>
    </div>
  );
}

interface Props {
  policyType: "Privacy Policy" | "Terms and Conditions of Sale";
}
